import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {injectIntl, defineMessages} from 'react-intl';

import {connect, ssr_wait} from '@stubhub/react-store-provider';

import ChildSeoLinks from '../react-child-seo-links';

import controller from './controller';

import './index.scss';

const LIST_TYPE = Object.freeze({
  DEFAULT: 0,
  GROUPING: 1,
  SPORTS: 2,
  CONCERT: 3,
  THEATER: 4,
});
const messages = defineMessages({
  Default: {id: 'Internal.SEO.Venue.Default.Title', defaultMessage: 'Venues'},
  Group: {id: 'Internal.SEO.Venue.Group.Title', defaultMessage: '{entityName} venues'},
  Concert: {id: 'Internal.SEO.Venue.Concert.Title', defaultMessage: '{entityName} tour venues'},
  Sports: {id: 'Internal.SEO.Venue.Sports.Title', defaultMessage: '{entityName} venues'},
  Theater: {id: 'Internal.SEO.Venue.Theater.Title', defaultMessage: 'Venues for {entityName}'},
});

class SeoPerformerVenues extends Component {
  @ssr_wait
  init(props) {
    const {loadVenues, venuesParams, geo} = props;

    return loadVenues(venuesParams, geo);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {loadVenues, geo: nextGeo} = nextProps;
    const {venuesParams, geo} = this.props;
    if (nextGeo && geo && nextGeo.key !== geo.key) {
      loadVenues(venuesParams, nextGeo, true);
    }
  }

  componentWillUnmount() {
    const {resetSeoPerformerVenues} = this.props;
    resetSeoPerformerVenues && resetSeoPerformerVenues();
  }

  UNSAFE_componentWillMount() {
    const {venueLinks} = this.props;
    if (!venueLinks) {
      this.init(this.props);
    }
  }
  render() {
    let {venueLinks = [], title} = this.props;
    const {entityType, entityId, type, intl, entityName} = this.props;
    if (venueLinks.length) {
      venueLinks = venueLinks.slice(0, MAX_VENUE_SEO_LINKS_COUNT);
    }
    if (!title) {
      switch (type) {
        case LIST_TYPE.DEFAULT:
          title = intl.formatMessage(messages.Default, {entityName});
          break;
        case LIST_TYPE.GROUPING:
          title = intl.formatMessage(messages.Group, {entityName});
          break;
        case LIST_TYPE.SPORTS:
          title = intl.formatMessage(messages.Sports, {entityName});
          break;
        case LIST_TYPE.CONCERT:
          title = intl.formatMessage(messages.Concert, {entityName});
          break;
        case LIST_TYPE.THEATER:
          title = intl.formatMessage(messages.Theater, {entityName});
          break;
      }
    }

    return venueLinks.length > 0 ? (
      <div className="EntityPage__SeoChildLinks Seo_Performer_Venues">
        <ChildSeoLinks
          className=""
          entityType={entityType}
          entityId={entityId}
          seoLinks={venueLinks}
          instanceId={`${entityType}-${entityId}`}
          title={<h2 className={`SeoInternalLinks__${entityType}__Title SeoInternalLinks__Title`}>{title}</h2>}
        />
      </div>
    ) : null;
  }
}
SeoPerformerVenues.propTypes = {
  entityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  entityType: PropTypes.string,
  entityName: PropTypes.string,
  venueLinks: PropTypes.array,
  venuesParams: PropTypes.object,
  geo: PropTypes.object,
  title: PropTypes.string,
  type: PropTypes.number,
  resetSeoPerformerVenues: PropTypes.func,

  /** The intl object */
  intl: PropTypes.object.isRequired,
};
export const MAX_VENUE_SEO_LINKS_COUNT = 20;

export {SeoPerformerVenues, LIST_TYPE};
export default connect(controller)(injectIntl(SeoPerformerVenues));
